export default "__VITE_ASSET__pDJa3768__"